import RSAA from "redux-api-middleware/es/RSAA";
import {defaultHeaders} from "../../../candidate/app/actions/actions";

export const types = {
    EMPLOYEE_ASSIGNMENTS_LIST: 'EMPLOYEE_ASSIGNMENTS_LIST',
    EMPLOYEE_ASSIGNMENTS_LIST_SUCCESS: 'EMPLOYEE_ASSIGNMENTS_LIST_SUCCESS',
    EMPLOYEE_ASSIGNMENTS_LIST_ERROR: 'EMPLOYEE_ASSIGNMENTS_LIST_ERROR',

    EMPLOYEE_ASSIGNMENT_EXECUTE: 'EMPLOYEE_ASSIGNMENT_EXECUTE',
    EMPLOYEE_ASSIGNMENT_EXECUTE_SUCCESS: 'EMPLOYEE_ASSIGNMENT_EXECUTE_SUCCESS',
    EMPLOYEE_ASSIGNMENT_EXECUTE_ERROR: 'EMPLOYEE_ASSIGNMENT_EXECUTE_ERROR'
};

export const employeeAssignmentsList = (namespace, employeeId) => {

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/${namespace}/employees/${employeeId}/assignments`,
            method: 'POST',
            headers: defaultHeaders,
            types: [
                types.EMPLOYEE_ASSIGNMENTS_LIST,
                types.EMPLOYEE_ASSIGNMENTS_LIST_SUCCESS,
                types.EMPLOYEE_ASSIGNMENTS_LIST_ERROR
            ],
            credentials: 'same-origin'
        },
        auth: true
    };

};

export const employeeAssignmentExecute = (namespace, employeeId, assignmentId, body) => {

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/${namespace}/employees/${employeeId}/assignments/${assignmentId}/execute`,
            method: 'POST',
            headers: defaultHeaders,
            types: [
                types.EMPLOYEE_ASSIGNMENT_EXECUTE,
                types.EMPLOYEE_ASSIGNMENT_EXECUTE_SUCCESS,
                types.EMPLOYEE_ASSIGNMENT_EXECUTE_ERROR
            ],
            credentials: 'same-origin',
            body: JSON.stringify(body)
        },
        auth: true
    };

};
